import withParams from "@src/components/widgets/HOC/withParams";
import React, { useMemo } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetHighlighProductUmamiParams } from "../interface";
import useCtaAction from "@src/components/widgets/hooks/useCtaAction";
import LandingHighlighProductUmami, {
  ICompositionVariant,
} from "design-system/src/Components/WidgetPart/LandingHighlighProduct/LandingHighllightProductUmami/LandingHighllightProductUmami";
import useCompositionBox from "@src/components/widgets/hooks/useCompositionBox";
import { useTranslation } from "@src/hooks/useTranslation";

const LandingStandardHighlightProductUmami: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetHighlighProductUmamiParams>((props) => {
    const { p } = props;
    const cta_action = p("cta_action");
    const isAddToCart: boolean = cta_action === "add_to_cart";
    const id_product = p("product") || p("id_product");
    const ctaLabel = p("cta_label") || "";
    const hideCta = p("hide_cta") === "1";
    const { t } = useTranslation("landing-standard");

    const { generateClick, getSubmitLabel } = useCtaAction(id_product || "");
    const { prepareCompositions, prepareProduct } = useCompositionBox();

    const productModel = prepareProduct(p("id_product") || "");

    const handleClick = generateClick(
      cta_action && cta_action === "open_link"
        ? {
            type: cta_action,
            link: p("link") || "#",
          }
        : {
            type: cta_action || "product_card",
          }
    );

    const compositions: ICompositionVariant = useMemo(() => {
      const productIds: string[] = (p("box_products") || "")
        .split(",")
        .map((id) => id.trim());
      const productQuantity: number[] = (p("box_products_itemnbr") || "")
        .split(",")
        .map((i) => +i);
      return {
        type: "box",
        list: prepareCompositions(productIds, productQuantity) || [],
      } as ICompositionVariant;
    }, [p, prepareCompositions]);

    return (
      <LandingHighlighProductUmami
        title={p("title") || ""}
        ctaLabel={isAddToCart ? getSubmitLabel(false, ctaLabel) : ctaLabel}
        description={p("description")}
        mentionDesktop={p("mention_desktop")}
        onClick={handleClick}
        compositionLabel={t("Composition", "landing-standard") || ""}
        compositions={compositions}

        hideCta={hideCta}
        price={productModel?.formatPrice()}
        priceSubtitle={
          productModel && productModel.getQuantity() > 1
            ? productModel.displayPieces()
            : undefined
        }
      />
    );
  });

export default LandingStandardHighlightProductUmami;
